export const emailValidator = email => {
    const name = 'emailValidator';
    const valid = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/.test(email);
    const errors = [];
    if (!valid) {
        errors.push('Invalid Email');
    }
    return { name: name, valid: valid, errors: errors };
};

export const requiredValidator = value => {
    const name = 'requiredValidator';
    const errors = [];
    let valid = true;
    if (!value) {
        valid = false;
        errors.push('This is a required field');
    }
    return { name: name, valid: valid, errors: errors };
};

export const passwordValidator = password => {
    const name = 'passwordValidator';
    const errors = [];
    let valid = true;
    if (password.length < 8) {
        valid = false;
        errors.push('Password must be between 8 - 16 characters');
    }
    return { name: name, valid: valid, errors: errors };
};

// export const passwordConfirmationValidator = passwordComponent => {
//     const name = 'passwordConfirmationValidator';
//     const errors = [];
//     let valid = true;
//     if (passwordComponent.value !== value) {
//         valid = false;
//         errors.push('Passwords do not match');
//     }
//     return { name: name, valid: valid, errors: errors };
// };



// WEBPACK FOOTER //
// ./src/modules/form/validators.js